import { DeviceApi } from './types';

const device: DeviceApi = {};

export { device };
export type { DeviceApi, Receipt, ReceiptText } from './types';
